import { create } from 'zustand';

interface UrlsStoreType {
  purchaseUrl: string;
  setPurchaseUrl: (url: string) => void;
}

const useUrlsStore = create<UrlsStoreType>((set) => ({
  purchaseUrl: '',
  setPurchaseUrl: (purchaseUrl) => set({ purchaseUrl }),
}));

export default useUrlsStore;
